module.exports = __webpack_public_path__ + "img/ic_qu_round.a4173d3d.svg";